/* ============================================================
   BioActive+ — Astaxanthin PDP (Dawn) — interactions
   Vanilla JS, no dependencies. Deferred, scoped to #astaxanthin-pdp.
   Reads markup written by the snippets via data-asta-* attributes.
   ============================================================ */
(function () {
  'use strict';
  var ROOT = document.getElementById('astaxanthin-pdp') || document.body;
  if (!ROOT) return;

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var fmt = function (n) {
    try {
      var num = Number(n); if (isNaN(num)) return n;
      var f = Math.abs(num - Math.round(num)) > 0.005;
      return num.toLocaleString('en-AE', { minimumFractionDigits: f ? 2 : 0, maximumFractionDigits: 2 });
    } catch (e) { return n; }
  };
  var CUR = (window.ASTAXANTHIN && window.ASTAXANTHIN.currency) || 'AED';

  function openCart(cart) {
    try {
      /* update BioActive header bag count */
      var cnt = cart ? cart.item_count : 0;
      document.querySelectorAll('.ba-bag-count').forEach(function (el) { el.textContent = cnt; });
      document.querySelectorAll('[data-bac-headcount]').forEach(function (el) { el.textContent = '(' + cnt + ')'; });
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    } catch (e) {}
    /* open BioActive cart drawer */
    if (typeof window.__bacOpenDrawer === 'function') window.__bacOpenDrawer();
  }

  function cartAdd(items, done) {
    var valid = items.filter(function (it) { return it.id; });
    if (!valid.length) { if (done) done(); return; }
    var sections = document.querySelector('[data-bac-drawer-host]') ? 'bioactive-cart-drawer' : '';
    var body = { items: valid };
    if (sections) { body.sections = sections; body.sections_url = window.location.pathname; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (res) {
        /* apply fresh drawer HTML */
        if (res.sections && typeof window.__bacApplySections === 'function') {
          window.__bacApplySections(res.sections);
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (done) done();
        openCart(cart);
      })
      .catch(function () { if (done) done(); });
  }

  /* ---------------- announcement ticker ---------------- */
  (function () {
    var msgs = $$('.pdp-announce-msg');
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('on');
    }, 3200);
  })();

  /* ---------------- smooth nav ---------------- */
  $$('[data-asta-nav]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id && id.charAt(0) === '#' && $(id)) {
        e.preventDefault();
        var el = $(id);
        if (id === '#top') window.scrollTo({ top: 0, behavior: 'smooth' });
        else window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 78, behavior: 'smooth' });
      }
    });
  });

  /* ---------------- gallery ---------------- */
  (function () {
    var g = $('[data-asta-gallery]'); if (!g) return;
    var slides = $$('[data-asta-slide]', g);
    var dotsWrap = $('[data-asta-dots]', g);
    var i = 0;
    slides.forEach(function (s, k) {
      var d = document.createElement('button');
      d.className = 'pdp-dot' + (k === 0 ? ' on' : '');
      d.setAttribute('aria-label', 'Slide ' + (k + 1));
      d.addEventListener('click', function () { go(k); });
      if (dotsWrap) dotsWrap.appendChild(d);
    });
    var dots = dotsWrap ? $$('.pdp-dot', dotsWrap) : [];
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    }
    var prev = $('[data-asta-prev]', g), next = $('[data-asta-next]', g);
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });

    /* mobile swipe — horizontal drag on the image advances slides (arrows hidden on mobile) */
    var swipeArea = $('.pdp-main', g) || g;
    var sx = 0, sy = 0, swiping = false;
    swipeArea.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; swiping = true;
    }, { passive: true });
    swipeArea.addEventListener('touchend', function (e) {
      if (!swiping) return; swiping = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) go(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
  })();

  /* ---------------- buy box: stacks + mode + freq + live price ---------------- */
  (function () {
    var form = $('[data-asta-form]'); if (!form) return;
    var stacks = $$('[data-asta-stack]', form);
    var modes = $$('[data-asta-mode]', form);
    var freqs = $$('[data-asta-freq]', form);
    var modesWrap = $('[data-asta-modes]', form);
    var subPct = modesWrap ? (parseFloat(modesWrap.getAttribute('data-sub-pct')) || 0) : 0;
    var variantInput = $('[data-asta-variant-input]', form);
    var planInput = $('[data-asta-plan-input]', form);
    var subDetail = $('[data-asta-subdetail]', form);

    var sel = stacks.filter(function (s) { return s.classList.contains('on'); })[0] || stacks[0];
    var mode = 'sub', freq = '30';
    var dm = $('[data-asta-mode="sub"]', form); if (!dm) mode = 'once';

    function cur(node, sel) { return node ? node.querySelector(sel) : null; }
    function num(el, a) { return parseFloat(el.getAttribute(a)) || 0; }

    function render() {
      if (!sel) return;
      var price = num(sel, 'data-price');
      var was = num(sel, 'data-was');
      if (mode === 'sub' && subPct) price = Math.round(price * (1 - subPct / 100) * 100) / 100;
      var save = was > price ? was - price : 0;
      var inst = Math.round(price / 4 * 100) / 100;
      var name = sel.getAttribute('data-name') || '';
      set('[data-asta-price-label]', name + ' · ' + (mode === 'sub' ? 'Subscription' : 'One-time'));
      set('[data-asta-price]', CUR + ' ' + fmt(price));
      var wasEl = $('[data-asta-was]', form); if (wasEl) { wasEl.style.display = was > price ? '' : 'none'; wasEl.textContent = CUR + ' ' + fmt(was); }
      var saveEl = $('[data-asta-save]', form); if (saveEl) { saveEl.style.display = save > 0 ? '' : 'none'; saveEl.textContent = 'Save ' + CUR + ' ' + fmt(save); }
      set('[data-asta-cta-price]', CUR + ' ' + fmt(price));
      set('[data-asta-instal]', CUR + ' ' + fmt(inst));
      // native cart wiring
      if (variantInput) variantInput.value = sel.getAttribute('data-variant') || '';
      if (planInput) {
        var plan = '';
        if (mode === 'sub') {
          var fb = freqs.filter(function (f) { return f.getAttribute('data-asta-freq') === freq; })[0];
          plan = fb ? (fb.getAttribute('data-plan') || '') : '';
        }
        planInput.value = plan;
        planInput.disabled = !plan;
      }
      if (subDetail) subDetail.style.display = mode === 'sub' ? '' : 'none';
      // mirror into sticky bar
      document.dispatchEvent(new CustomEvent('asta:price', { detail: { name: name, price: price, was: was, save: save, qty: num(sel, 'data-qty') } }));
    }
    function set(s, v) { var e = $(s, form) || $(s); if (e) e.textContent = v; }

    stacks.forEach(function (s) {
      s.addEventListener('click', function () {
        stacks.forEach(function (x) { x.classList.remove('on'); });
        s.classList.add('on'); sel = s; render();
      });
    });
    modes.forEach(function (m) {
      m.addEventListener('click', function () {
        mode = m.getAttribute('data-asta-mode');
        modes.forEach(function (x) { x.classList.toggle('on', x === m); });
        render();
      });
    });
    freqs.forEach(function (f) {
      f.addEventListener('click', function () {
        freq = f.getAttribute('data-asta-freq');
        freqs.forEach(function (x) { x.classList.toggle('on', x === f); });
        render();
      });
    });
    render();
    
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var vid = variantInput ? variantInput.value : '';
        if (!vid) {
          document.dispatchEvent(new CustomEvent('asta:toast', { detail: 'Added to your bag' }));
          return;
        }
        var pid = planInput ? planInput.value : '';
        var item = { id: vid, quantity: parseInt(sel.getAttribute('data-qty'), 10) || 1 };
        if (pid) item.selling_plan = pid;
        
        var submitBtn = form.querySelector('[type="submit"]') || form.querySelector('.pdp-pb-cta');
        if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');
        
        cartAdd([item], function () {
          if (submitBtn) submitBtn.removeAttribute('aria-busy');
          document.dispatchEvent(new CustomEvent('asta:toast', { detail: 'Added to your bag' }));
        });
      });
    }

    ROOT.__astaBuy = { getSel: function () { return sel; }, getMode: function () { return mode; }, submit: function () {
      if (form) {
        var event = new Event('submit', { cancelable: true, bubbles: true });
        form.dispatchEvent(event);
      }
    } };
  })();

  /* ---------------- why play-off ---------------- */
  (function () {
    var cards = $$('[data-asta-why-card]'); if (!cards.length) return;
    var panel = $('[data-asta-why-panel]'); if (!panel) return;
    var tag = $('[data-asta-why-tag]', panel), big = $('[data-asta-why-big]', panel),
        cap = $('[data-asta-why-cap]', panel), cols = $('[data-asta-why-cols]', panel);
    function show(card) {
      cards.forEach(function (c) { c.classList.toggle('on', c === card); });
      var acc = card.getAttribute('data-acc') || 'lilac';
      panel.className = 'pdp-why2-panel acc-' + acc;
      if (tag) tag.textContent = card.getAttribute('data-title') || '';
      if (big) big.innerHTML = (card.getAttribute('data-k') || '') + '<span>' + (card.getAttribute('data-u') || '') + '</span>';
      if (cap) cap.textContent = card.getAttribute('data-caption') || '';
      var bars = [];
      try { bars = JSON.parse(card.getAttribute('data-bars') || '[]'); } catch (e) {}
      if (cols) {
        cols.innerHTML = bars.map(function (b) {
          return '<div class="pdp-why2-col' + (b.hi ? ' win' : '') + '">' +
            '<span class="pdp-why2-coltrack"><span class="pdp-why2-colfill" style="height:0%">' +
            '<span class="pdp-why2-colval">' + b.d + '</span>' + (b.hi ? '<span class="pdp-why2-crown">✦</span>' : '') +
            '</span></span><span class="pdp-why2-collbl">' + b.l + (b.hi ? '<em>winner</em>' : '') + '</span></div>';
        }).join('');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            $$('.pdp-why2-colfill', cols).forEach(function (f, k) {
              f.style.transitionDelay = (k * 90) + 'ms';
              f.style.height = Math.max(bars[k].v, 6) + '%';
            });
          });
        });
      }
    }
    cards.forEach(function (c) { c.addEventListener('click', function () { show(c); }); });
    show(cards[0]);
  })();

  /* ---------------- mechviz tabs ---------------- */
  (function () {
    var tabs = $$('[data-asta-mech-tab]'); if (!tabs.length) return;
    var panels = $$('[data-asta-mech-panel]');
    function show(n) {
      tabs.forEach(function (t) { t.classList.toggle('on', t.getAttribute('data-asta-mech-tab') === n); });
      panels.forEach(function (p) { p.classList.toggle('on', p.getAttribute('data-asta-mech-panel') === n); });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-asta-mech-tab')); }); });
  })();

  /* ---------------- timeline ---------------- */
  (function () {
    var steps = $$('[data-asta-tl-step]'); if (!steps.length) return;
    var fill = $('[data-asta-tl-fill]'), wkEl = $('[data-asta-tl-wk]'), ttlEl = $('[data-asta-tl-ttl]'),
        txtEl = $('[data-asta-tl-text]'), headEl = $('[data-asta-tl-head]'), metricsWrap = $('[data-asta-tl-metrics]');
    var metricDefs = [];
    if (metricsWrap) { try { metricDefs = JSON.parse(metricsWrap.getAttribute('data-metrics') || '[]'); } catch (e) {} }
    function show(idx) {
      var i = parseInt(idx, 10);
      steps.forEach(function (s, k) {
        s.classList.toggle('active', k === i);
        s.classList.toggle('done', k <= i);
        var dot = s.querySelector('.pdp-tl-dot'); if (dot) dot.innerHTML = k <= i ? '✓' : '';
      });
      var pct = (i / (steps.length - 1)) * 100;
      if (fill) fill.style.width = 'calc(' + pct + '% - ' + (pct / 100 * 28) + 'px + 14px)';
      var s = steps[i];
      if (wkEl) wkEl.textContent = s.getAttribute('data-wk');
      if (ttlEl) ttlEl.textContent = s.getAttribute('data-ttl');
      if (txtEl) txtEl.textContent = s.getAttribute('data-text');
      if (headEl) headEl.textContent = 'Cumulative improvement by ' + (s.getAttribute('data-wk') || '').toLowerCase();
      var m = {};
      try { m = JSON.parse(s.getAttribute('data-metrics') || '{}'); } catch (e) {}
      if (metricsWrap) {
        var grid = $('[data-asta-tl-grid]', metricsWrap);
        if (grid) grid.innerHTML = metricDefs.map(function (d) {
          var v = m[d.key] || 0;
          return '<div class="pdp-metric"><div class="pdp-metric-top"><span class="lbl">' + d.label + '</span><span class="v">+' + v + '%</span></div>' +
            '<div class="bb-barh-track"><span class="bb-barh-fill" style="width:' + v + '%"></span></div></div>';
        }).join('');
      }
    }
    steps.forEach(function (s) { s.addEventListener('click', function () { show(s.getAttribute('data-asta-tl-step')); }); });
    show('2');
  })();

  /* ---------------- FAQ accordion ---------------- */
  (function () {
    var items = $$('[data-asta-faq-item]');
    items.forEach(function (it) {
      var q = $('[data-asta-faq-q]', it);
      if (!q) return;
      q.addEventListener('click', function () {
        var open = it.classList.contains('open');
        items.forEach(function (x) { x.classList.remove('open'); });
        if (!open) it.classList.add('open');
      });
    });
  })();

  /* ---------------- bundle builder ---------------- */
  (function () {
    var bundle = $('[data-asta-bundle]'); if (!bundle) return;
    var chips = $$('[data-asta-bundle-chip]', bundle);
    var slotsWrap = $('[data-asta-slots]', bundle);
    var fill = $('[data-asta-bundle-fill]', bundle);
    var nodes = $$('[data-asta-bundle-node]', bundle);
    var msgEl = $('[data-asta-bundle-msg]', bundle);
    var sumWrap = $('[data-asta-bundle-summary]', bundle);
    var cta = $('[data-asta-bundle-cta]', bundle);
    var picks = [];
    function item(id) { return chips.filter(function (c) { return c.getAttribute('data-id') === id; })[0]; }
    function info(c) { return { id: c.getAttribute('data-id'), nm: c.getAttribute('data-nm'), price: parseFloat(c.getAttribute('data-price')) || 0,
      variant: c.getAttribute('data-variant') || '', c1: c.getAttribute('data-c1'), c2: c.getAttribute('data-c2'), bottle: c.getAttribute('data-bottle') }; }
    function tier(n) { return n <= 0 ? 0 : n === 1 ? 10 : n === 2 ? 20 : 30; }

    function render() {
      var pct = tier(picks.length);
      var subtotal = picks.reduce(function (a, c) { return a + info(c).price; }, 0);
      var savings = Math.round(subtotal * pct / 100);
      var total = subtotal - savings;
      var fillPct = (Math.min(picks.length, 3) / 3) * 100;
      if (fill) fill.style.width = fillPct + '%';
      nodes.forEach(function (n, k) { n.classList.toggle('on', picks.length >= k); var dot = n.querySelector('.dot'); if (dot) dot.innerHTML = (picks.length >= k && k > 0) ? '✓' : ''; });
      if (msgEl) msgEl.textContent = picks.length === 0 ? 'Add a formula to start saving'
        : picks.length >= 3 ? 'Maximum 30% off unlocked' : 'Nice — ' + pct + '% off your stack so far';
      // slots
      if (slotsWrap) {
        var html = '';
        for (var i = 0; i < 4; i++) {
          var c = picks[i];
          if (c) {
            var d = info(c);
            html += '<button class="mag-bundle-slot filled" data-rm="' + i + '" title="Remove">' +
              '<span class="mag-bundle-tile" style="background:linear-gradient(158deg,' + d.c1 + ',' + d.c2 + ')"><span class="mag-bundle-bottle" style="background:' + d.bottle + '"></span></span>' +
              '<span class="mag-bundle-slot-nm">' + d.nm + '</span><span class="mag-bundle-x">✕</span></button>';
          } else {
            var next = i === picks.length ? ' next' : '';
            html += '<div class="mag-bundle-slot empty' + next + '"><span class="mag-bundle-plus">+</span></div>';
          }
        }
        slotsWrap.innerHTML = html;
        $$('[data-rm]', slotsWrap).forEach(function (b) { b.addEventListener('click', function () { picks.splice(parseInt(b.getAttribute('data-rm'), 10), 1); sync(); render(); }); });
      }
      // summary
      if (sumWrap) {
        if (picks.length === 0) {
          sumWrap.innerHTML = '<div class="mag-bundle-empty"><p>Your stack is empty.</p><p>Add formulas to see your savings.</p></div>';
        } else {
          var rows = picks.map(function (c, i) { var d = info(c);
            return '<div class="mag-bundle-row"><span class="mag-bundle-row-dot" style="background:linear-gradient(158deg,' + d.c1 + ',' + d.c2 + ')"></span>' +
              '<span class="mag-bundle-row-nm">' + d.nm + '</span><span class="mag-bundle-row-pr">' + CUR + ' ' + fmt(d.price) + '</span>' +
              '<button class="mag-bundle-row-x" data-rm2="' + i + '" aria-label="Remove">✕</button></div>'; }).join('');
          sumWrap.innerHTML = rows + '<div class="mag-bundle-totals">' +
            '<div class="r"><span>Subtotal</span><span>' + CUR + ' ' + fmt(subtotal) + '</span></div>' +
            '<div class="r save"><span>Discount · ' + pct + '%</span><span>− ' + CUR + ' ' + fmt(savings) + '</span></div>' +
            '<div class="r total"><span>Total</span><span>' + CUR + ' ' + fmt(total) + '</span></div></div>';
          $$('[data-rm2]', sumWrap).forEach(function (b) { b.addEventListener('click', function () { picks.splice(parseInt(b.getAttribute('data-rm2'), 10), 1); sync(); render(); }); });
        }
      }
      if (cta) { cta.classList.toggle('off', picks.length === 0); cta.disabled = picks.length === 0; }
    }
    function sync() { chips.forEach(function (c) { var on = picks.indexOf(c) !== -1; c.classList.toggle('on', on); c.classList.toggle('dis', !on && picks.length >= 4); }); }

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var ix = picks.indexOf(c);
        if (ix !== -1) picks.splice(ix, 1);
        else if (picks.length < 4) picks.push(c);
        sync(); render();
      });
    });
    if (cta) cta.addEventListener('click', function () {
      if (!picks.length) return;
      var items = picks.map(function (c) { return { id: info(c).variant, quantity: 1 }; }).filter(function (x) { return x.id; });
      cta.classList.add('done'); cta.innerHTML = 'Adding...';
      cartAdd(items, function () {
        cta.innerHTML = '✓ Stack added';
        document.dispatchEvent(new CustomEvent('asta:toast', { detail: 'Stack of ' + picks.length + ' added to your bag' }));
        setTimeout(function () { cta.classList.remove('done'); cta.innerHTML = 'Add stack to cart →'; }, 1800);
      });
    });
    // pre-select any chip flagged data-preselect (matches the design default)
    chips.forEach(function (c) { if (c.getAttribute('data-preselect') === 'true' && picks.length < 4) picks.push(c); });
    sync();
    render();
  })();

  /* ---------------- sticky add-to-cart bar ---------------- */
  (function () {
    var bar = $('[data-asta-sticky]'); if (!bar) return;
    var buybox = $('[data-asta-buybox]');
    var titleEl = $('[data-asta-sticky-meta]', bar), priceEl = $('[data-asta-sticky-price]', bar),
        wasEl = $('[data-asta-sticky-was]', bar), saveEl = $('[data-asta-sticky-save]', bar);
    var addBtn = $('[data-asta-sticky-add]', bar);
    document.addEventListener('asta:price', function (e) {
      var d = e.detail;
      if (titleEl) titleEl.textContent = d.name + ' · ' + (d.qty > 1 ? d.qty + ' boxes' : '1 box');
      if (priceEl) priceEl.textContent = CUR + ' ' + fmt(d.price);
      if (wasEl) { wasEl.style.display = d.was > d.price ? '' : 'none'; wasEl.textContent = CUR + ' ' + fmt(d.was); }
      if (saveEl) { saveEl.style.display = d.save > 0 ? '' : 'none'; saveEl.innerHTML = '✓ Save ' + CUR + ' ' + fmt(d.save); }
    });
    if (addBtn) addBtn.addEventListener('click', function () { if (ROOT.__astaBuy) ROOT.__astaBuy.submit(); });
    if (buybox) {
      window.addEventListener('scroll', function () {
        var b = buybox.getBoundingClientRect().bottom;
        var nearEnd = document.body.scrollHeight - window.innerHeight - 520;
        bar.classList.toggle('show', b < 80 && window.scrollY < nearEnd);
      }, { passive: true });
    }
  })();

  /* ---------------- toast ---------------- */
  document.addEventListener('asta:toast', function (e) {
    var t = document.createElement('div');
    t.className = 'bb-toast'; t.textContent = '✓ ' + e.detail;
    ROOT.appendChild(t);
    setTimeout(function () { t.remove(); }, 2300);
  });

  /* ---------------- clinical rings + scroll reveal ---------------- */
  (function () {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        if (el.hasAttribute('data-asta-clinical')) {
          $$('.mag-clin-card', el).forEach(function (c) { c.classList.add('in'); });
          $$('.mag-clin-ring .prog', el).forEach(function (p) {
            var pct = parseFloat(p.getAttribute('data-pct')) || 0;
            var C = 2 * Math.PI * 40;
            p.style.strokeDasharray = C;
            p.style.strokeDashoffset = C * (1 - pct / 100);
          });
        }
        if (el.classList.contains('pdp-pw-vs')) el.classList.add('in');
        if (el.classList.contains('pdp-reveal')) el.classList.add('in');
        io.unobserve(el);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    $$('[data-asta-clinical], .pdp-pw-vs, .pdp-reveal').forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      $$('[data-asta-clinical]').forEach(function (el) {
        $$('.mag-clin-card', el).forEach(function (c) { c.classList.add('in'); });
        $$('.mag-clin-ring .prog', el).forEach(function (p) { var pct = parseFloat(p.getAttribute('data-pct')) || 0; var C = 2 * Math.PI * 40; p.style.strokeDasharray = C; p.style.strokeDashoffset = C * (1 - pct / 100); });
      });
      $$('.pdp-reveal').forEach(function (el) { el.classList.add('in'); });
      $$('.pdp-pw-vs').forEach(function (el) { el.classList.add('in'); });
    }, 800);
  })();

})();
